module.exports = __webpack_public_path__ + "img/youtube.9638dc81.svg";